/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { all, any } from 'cio/app-models/conditions/group';

interface ConditionLogicalOperatorLabelArgs {
  operator?: typeof all | typeof any | null;
}

export default class ConditionLogicalOperatorLabelComponent extends Component<ConditionLogicalOperatorLabelArgs> {
  get operator() {
    return (this.args.operator ?? all).toLowerCase();
  }
}
